import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(
    private snackbar: MatSnackBar
  ) { }

  default(message: string): MatSnackBarRef<SimpleSnackBar> {
    const config: MatSnackBarConfig = {
      direction: 'rtl',
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      duration: 3000
    }

    return this.snackbar.open(message, '', config);
  }
}
